import React, { Component } from "react"
import PropTypes from "prop-types"
import { Image } from "react-feather"
import fetch from "cross-fetch"
import queryString from "query-string"
import SbEditable from "storyblok-react"
import { forEach, endsWith } from "lodash"

import Components from "../../components"
import Form from "../formstack-form"
import Button from "../button"

class AmbassadorProfile extends Component {
  state = {
    loading: true,
    found: false,
    ambassador: {},
    onSumbitFormData: {},
    completed: false,
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      const query = queryString.parse(window.location.search)
      const id = query.cid

      if (id) {
        fetch(`${process.env.GATSBY_HULTEDUDATA_API}/ambassador/${id}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((res) => {
            if (res.status >= 400) {
              throw new Error("Bad response from server")
            }
            return res.json()
          })
          .then((result) => {
            this.setState({
              loading: false,
              found: result.found,
              ambassador: result._source,
            })
          })
          .catch((err) => {
            console.error(err)
            this.setState({
              loading: false,
            })
          })
      }
    }
  }

  onFormSubmit = (fieldData, data) => {
    const { ambassador } = this.state
    const enquiryData = {
      ambassadorName: `${ambassador.FirstName} ${ambassador.LastName}`,
    }
    let ambassadorId, phone, email

    forEach(fieldData, (field) => {
      switch (true) {
        case field.name === "ambassadorid":
          ambassadorId = data[`field_${field.id}`]
          break
        case field.name === "name":
          enquiryData.leadName = `${data[`field_${field.id}`].first} ${
            data[`field_${field.id}`].last
          }`
          break
        case endsWith(field.name, "sf_phonenumber"):
          phone = data[`field_${field.id}`]
          break
        case endsWith(field.name, "sf_email"):
          email = data[`field_${field.id}`]
          break
        case endsWith(field.name, "sf_selectyourprogram"):
          enquiryData.programParsed = data[`field_${field.id}`]
          break
        case endsWith(field.name, "sf_countrycode"):
          enquiryData.countryOfResidence = data[`field_${field.id}`]
          break
        default:
          break
      }
    })

    fetch(process.env.GATSBY_AMBASSADORS_API, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        phone,
        ambassadorId,
        email,
        enquiryData,
      }),
    }).then(
      (response) => {
        console.info(response)
        this.setState({ completed: true })
      },
      (error) => {
        console.error(error)
        this.setState({ completed: true })
      }
    )
  }

  render() {
    const { ambassador, completed } = this.state
    const { blok } = this.props
    const ambObj = { ambassadorid: ambassador.Id }

    return (
      <SbEditable content={blok}>
        <div className="grid grid--gutters-sm">
          <div className="grid__col ambassador-profile">
            {blok.back_button &&
              blok.back_button.map((content) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                  className: "btn--reverse",
                })
              )}
          </div>
        </div>
        <div className="grid grid--gutters-sm">
          <div className="grid__col ambassador-profile">
            <Button
              href="#ambassador-profile-form"
              className="btn--cta ambassador-profile__button btn--sm-wide"
              text={`Get in touch with ${ambassador.FirstName}`}
              iconName="ArrowDown"
            />
            <div
              className={`ambassador-profile__image ${
                ambassador.image ? "" : "ambassador-profile__image--placeholder"
              }`}
            >
              {!ambassador.image && <Image />}
              {ambassador.image && (
                <img
                  className="lazyload ambassador-profile__img"
                  data-src={ambassador.image}
                  alt={`${ambassador.FirstName} ${ambassador.LastName}`}
                  title={`${ambassador.FirstName} ${ambassador.LastName}`}
                />
              )}
            </div>
            <div className="ambassador-profile__details">
              <p className="ambassador-profile__name heading heading--accent">
                {ambassador.FirstName} {ambassador.LastName}
              </p>
              <p className="ambassador-profile__heading">
                {ambassador.ProgramTitle}, {ambassador.Campus}
              </p>
              <p>{ambassador.Interests}</p>
              <br></br>
              <p className="ambassador-profile__bio">{ambassador.Biography}</p>
              <br></br>
            </div>
          </div>
          <div className="grid__col ambassador-profile__form">
            <div id="ambassador-profile-form" className="card card--pd-md">
              {!completed ? (
                <Form
                  blok={this.props.blok.ambassador_form[0]}
                  prefillValues={ambObj}
                  onSumbitFormData={this.onFormSubmit}
                ></Form>
              ) : (
                <>
                  <p className="ambassador-profile__completed">
                    {this.props.blok.ambassador_form[0].thank_you_copy[0].copy}
                  </p>
                  {blok.contact &&
                    blok.contact.map((content) =>
                      React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                        className: "contact-method__link",
                      })
                    )}
                </>
              )}
            </div>
          </div>
        </div>
      </SbEditable>
    )
  }
}

AmbassadorProfile.defaultProps = {
  ambassador_form: [],
  thank_you_copy: [],
  whatsapp_img: [],
  sms_img: [],
}

AmbassadorProfile.propTypes = {
  blok: PropTypes.shape({
    ambassador_form: PropTypes.arrayOf(
      PropTypes.shape({
        formId: PropTypes.string.isRequired,
        thank_you_copy: PropTypes.arrayOf(
          PropTypes.shape({
            copy: PropTypes.string,
          })
        ),
      })
    ),
    contact: PropTypes.arrayOf(PropTypes.object),
    back_button: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
}

export default AmbassadorProfile
